import * as React from "react"


const LineS3 = React.forwardRef((props, pathRef) => {
        return (
            <svg
                id={"line-s-3"}
                width={320}
                height={951}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            viewBox={`0 0 320 951`}
                preserveAspectRatio={`none`}
            >


                <path
                    d="M160 .5v92c0 38.108-30.892 69-69 69H68c-37.003 0-67 29.997-67 67V951"
                    stroke="#DEDDE2"
                    ref={pathRef}

                    strokeWidth={2}
                    strokeDashoffset={props.normalizedPosition}
                    strokeDasharray={props.pathLength}
                />
                <path
                    d="M160 .5v92c0 38.108 30.892 69 69 69h23c37.003 0 67 29.997 67 67V951"
                    stroke="transparent"
                    strokeWidth={2}/>

            </svg>
        )
    }
)

export default LineS3;
